import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { formatMoney, formatDate, sourceLabel } from "@/lib/api";
import { SourcePill, StatusTag } from "@/components/Tags";

export default function Results() {
  const [rows, setRows] = useState([]);
  const [source, setSource] = useState("all");

  useEffect(() => {
    const params = { status: "sold" };
    if (source !== "all") params.source = source;
    api.get("/lots", { params }).then((r) => setRows(r.data));
  }, [source]);

  return (
    <div className="space-y-6" data-testid="results-page">
      <div>
        <h1 className="text-2xl md:text-3xl font-extrabold text-[color:var(--caa-charcoal)]">
          Sold results
        </h1>
        <p className="text-sm text-[color:var(--caa-muted)] mt-1">
          Every closed sale tracked by CAA. Filter by source to compare price behaviour.
        </p>
      </div>

      <div className="caa-segmented" data-testid="results-source-segmented">
        {["all", "pickles", "slattery", "ross", "ritchiebros"].map((k) => (
          <button key={k} data-active={source === k} onClick={() => setSource(k)}
            data-testid={`results-src-${k}`}>
            {k === "all" ? "All" : sourceLabel(k)}
          </button>
        ))}
      </div>

      <div className="caa-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="caa-table">
            <thead>
              <tr>
                <th>Machine</th>
                <th>Source</th>
                <th>Closed</th>
                <th>Status</th>
                <th className="text-right">Sold price</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 && (
                <tr>
                  <td colSpan={5} className="text-center py-10 text-[color:var(--caa-muted)]">
                    No sold results yet for this source.
                  </td>
                </tr>
              )}
              {rows.map((l) => (
                <tr key={l.id}>
                  <td>
                    <Link to={`/lots/${l.id}`}
                      className="font-semibold text-[color:var(--caa-charcoal)] hover:text-[color:var(--caa-teal-deep)]">
                      {l.title}
                    </Link>
                    <div className="text-xs text-[color:var(--caa-muted)] mt-0.5">
                      {[l.year, l.make, l.model_name].filter(Boolean).join(" · ")}
                    </div>
                  </td>
                  <td><SourcePill source={l.source} /></td>
                  <td className="text-sm">
                    {formatDate(l.actual_close_at || l.closing_at)}
                  </td>
                  <td><StatusTag status={l.status} /></td>
                  <td className="text-right caa-num font-bold" style={{ color: "var(--caa-teal-deep)" }}>
                    {formatMoney(l.final_bid || l.current_bid)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
